export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const API_FULL_FORMAT = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';
export const DATE_FORMAT = 'DD.MM.YYYY';
export const DATE_TIME_FORMAT = 'DD.MM.YYYY H:mm';
export const TIME_FORMAT = 'H:mm';



// WEBPACK FOOTER //
// ./src/constants/date.js